import React from "react";
import "./WhatXenaChat.css";

function WhatisXenaChat() {
  return (
    <div className="xenachat-container">

      <section className="getting-started">
        <h2>Getting Started</h2>
        <h3>What is XenaChat?</h3>
        <p>
          Create a powerful, no-code AI chatbot in just a few clicks. Looking to launch an intelligent
          chatbot on your website—without hiring developers or writing complex scripts? XenaChat makes it simple.
        </p>
        <p>
          Designed for businesses that want smarter customer interactions, XenaChat lets you build, train,
          and deploy a fully customized AI assistant tailored to your brand and data. No technical skills required.
        </p>
        <p>
          Whether your goal is customer support, lead generation, onboarding, or product guidance, XenaChat
          helps you create a conversational experience that feels natural, responsive, and aligned with your business needs.
        </p>
      </section>

      <section className="why-choose">
        <h3>Why Choose XenaChat?</h3>
        <ul>
          <li><strong>Zero coding required:</strong>  Set up your chatbot using an intuitive interface.</li>
          <li><strong>Train on your own content:</strong>  Upload documents, FAQs, website links, or knowledge bases.</li>
          <li><strong>Quick website integration</strong>  Add XenaChat to your site with a simple embed snippet.</li>
          <li><strong>Smart, contextual responses:</strong>  Deliver accurate answers based on your data.</li>
        </ul>
        <p>
          From startups to enterprises, XenaChat empowers teams to automate conversations while maintaining a personalized touch.
        </p>
      </section>

      <section className="ai-models">
        <h3>Available AI Models in XenaChat</h3>
        <p>
          XenaChat supports multiple advanced AI engines, allowing you to choose the right balance of
          performance, speed, and cost for your needs.
        </p>
        <p>Currently, XenaChat integrates with the following four AI platforms:</p>
        <ul>
          <li><strong>Azure OpenAI:</strong>  Enterprise-grade deployment with strong security and scalability.</li>
          <li><strong>OpenAI:</strong>  Advanced GPT models for accurate, context-aware conversations.</li>
          <li><strong>Google AI:</strong>  Powerful language models optimized for performance and multilingual capabilities.</li>
          <li><strong>Meta AI:</strong>  Efficient large language models built for speed and scalable applications.</li>
        </ul>
      </section>
    </div>
  );
}
export default WhatisXenaChat;